import { flagFactory } from '../icon';
import Svg from './si.svg';

export default flagFactory(Svg);
